module.exports = __webpack_public_path__ + "img/nl_Ecran 4.f66606b8.png";